import { PAGE_CONST, CLINICAL_SCORE } from "../constant/page-constants";

export const redirect = (navigate, page, data = {}) => {

    switch (page) {
        case PAGE_CONST.LOGIN:
            navigate('/login');
            break;
        case PAGE_CONST.HOME_PAGE:
            navigate('/home-page');
            break;
        case PAGE_CONST.PATIENT_BOOK:
            navigate('/patient-book');
            break;
        case PAGE_CONST.BED_DETAILS:
            navigate(`/bed-details/${data.bedId}`)
            break;
        case CLINICAL_SCORE.GCS_SCORE:
            navigate(`/gcs-score/${data.bedId}`)
            break;
        case CLINICAL_SCORE.SOFA_SCORE:
            navigate(`/sofa-score/${data.bedId}`)
            break;
        case CLINICAL_SCORE.FALL_RISK:
            navigate(`/fall-risk/${data.bedId}`)
            break;
        case CLINICAL_SCORE.BRADEN_SCORE:
            navigate(`/braden-score/${data.bedId}`)
            break;
        case CLINICAL_SCORE.RASS_SCORE:
            navigate(`/rass-score/${data.bedId}`)
            break;
        case CLINICAL_SCORE.APACHE_2_SCORE:
            navigate(`/apache-2-score/${data.bedId}`)
            break;
    }
}